import { render, staticRenderFns } from "./Susa.vue?vue&type=template&id=254d8a0c&"
import script from "./Susa.vue?vue&type=script&lang=js&"
export * from "./Susa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports